import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageMotherF.module.scss";

function PageMotherF() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p18", "png", s.content);

  const back = getImgSet("back__p22", "png");

  return (
    <div className={s.root}>
      <div className={s.inner}>
        {content}
        <Link to="/mother/e" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageMotherF, true, false, true);
